module.exports = __webpack_public_path__ + "static/17-72051221eb013a7ceabbbcd84e370613.wav";